export default "__VITE_ASSET__CnYD6HJA__"